import React from 'react';
import Button from '../ui/Button';
import gabmicLogo from '../../assets/gabmic-logo.png';

const LandingNavbar: React.FC = () => {
  const navStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 2rem',
    backgroundColor: 'var(--bg-background)',
    borderBottom: '1px solid var(--border-color)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  };

  const linkGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '2rem',
    alignItems: 'center',
  };

  const linkStyle: React.CSSProperties = {
    color: 'var(--text-main)',
    fontFamily: 'var(--font-mono, "JetBrains Mono", monospace)',
    fontSize: '0.85rem',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontWeight: 500,
  };

  const actionGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  };

  return (
    <header style={navStyle}>
      <div className="nav-logo">
        <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={gabmicLogo} alt="GabMic" style={{ height: '34px', width: 'auto' }} />
        </a>
      </div>

      <nav style={linkGroupStyle} className="desktop-only">
        <a href="#about" style={linkStyle}>About</a>
        <a href="#how-it-works" style={linkStyle}>How It Works</a>
        <a href="#analytics" style={linkStyle}>Analytics</a>
        <a href="/pricing" style={linkStyle}>Pricing</a>
      </nav>

      <div style={actionGroupStyle}>
        <a href="/signin">
          <Button variant="ghost" size="sm">
            Sign In
          </Button>
        </a>
        <a href="/signup">
          <Button variant="primary" size="sm">
            Create Account
          </Button>
        </a>
      </div>
    </header>
  );
};

export default LandingNavbar;
